import React from "react";
import { Create, Datagrid, DateField, BooleanField, Edit, List, SelectInput, Show, usePermissions, RichTextField, FileField, Tab, TabbedShowLayout, TextField, TextInput, TabbedForm, FormTab, ArrayInput, SimpleFormIterator, DateInput, BooleanInput, NumberField, ArrayField, AutocompleteInput, Filter, FormDataConsumer, ShowButton, EditButton, FunctionField, downloadCSV } from 'react-admin';
import RecordSummery from "../components/recordSummery";
import Typography from "@mui/material/Typography";


// import { DateInput } from 'react-admin-date-inputs2';

import { CustomToolbar, FamilyForm, PersonalFormContent, PlaceFormContent, StoryContent, RecordAutocompleteInput } from "../helpers/commonForms";
import LightBoxField from "../uiComponents/lightBoxField";
import RecordAvatar from "../uiComponents/RecordAvatar";
import RecordActions from "../components/recordActions";
import BeneficiaryPayments from "../components/beneficiaryPayments";
import RecordBulkActions from "../components/recordBulkActions";
import ListPagination from "../uiComponents/ListPagination";
import moment from "moment";
import { useState, useEffect } from "react";
import gql from "graphql-tag";
import { client } from "../helpers/apolloClient";
const getInitials = (name) => {
    if (!name) return '?';
    return name.split(' ').filter(w => w.length > 0).slice(0, 2).map(w => w[0]).join('').toUpperCase();
};

// export const ReviewToolbar = props => (
//     <Toolbar {...props} >
//
//         <DeleteButton redirect={props.redirect}/>
//
//     </Toolbar>
// );


const AREAS_QUERY = gql`
    query UniqueRecordAreas {
        uniqueRecordAreas
    }
`;

const SUBCITIES_QUERY = gql`
    query UniqueRecordSubcities {
        uniqueRecordSubcities
    }
`;

const useUniqueOptions = (query) => {
    const [options, setOptions] = useState([]);
    useEffect(() => {
        client.query({ query }).then(({ data }) => {
            const key = Object.keys(data)[0];
            setOptions(data[key].map(v => ({ id: v, name: v })));
        }).catch(() => {});
    }, [query]);
    return options;
};

const RecordFilter = (props) => {
    const areas = useUniqueOptions(AREAS_QUERY);
    const subcities = useUniqueOptions(SUBCITIES_QUERY);
    return (
    <Filter {...props}>
        {/*<TextInput label="Search by Registration ID" source="registrationId" alwaysOn />*/}

        <RecordAutocompleteInput label="Search Record" source="_id" alwaysOn emptyText="All Records" />

        <SelectInput alwaysOn emptyText="All Places"   source="placeType" label='Place Type' choices={[
            {id: "Orphanage", name: 'Orphanage'},
            {id: "Rental", name: 'Rental'},
            {id: "Private", name: 'Private'},
            {id: "Kebele", name: 'Kebele'},

        ]}/>
        <AutocompleteInput source="place.address.area" label="Area" choices={areas} />
        <AutocompleteInput source="place.address.subcity" label="Sub City" choices={subcities} />
        <SelectInput alwaysOn emptyText="All Genders"   source="gender" label='Gender' choices={[
            {id: "Male", name: 'Male'},
            {id: "Female", name: 'Female'},



        ]}/>
        <SelectInput label="Education Level"  source="currentEducation.level" choices={[
            {id: "None", name: 'None'},
            {id: "Kindergarten", name: 'Kindergarten'},
            {id: "Elementary", name: 'Elementary'},
            {id: "High School", name: 'High School'},
            {id: "Higher Education", name: 'Higher Education'},
            {id: "Other", name: 'Other'},
        ]}/>
        <SelectInput label="School Type"   source="currentEducation.schoolType" choices={[
            {id: "Government", name: 'Government'},
            {id: "Private", name: 'Private'},
        ]}/>
        <BooleanInput label="Official" source="official" />
        <SelectInput emptyText="All"   source="status" label='Status' choices={[
            {id: "Active", name: 'Active'},
            {id: "Discontinued", name: 'Discontinued'},


        ]}/>
    </Filter>
)
}



const recordExporter = (records) => {
    const headers = [
        'Registration Number',
        'Full Name',
        'Birth Date',
        'Age',
        'Registered Date',
        'Subcity',
        'Area',
        'Location Text',
    ];

    const csvRows = records.map(record => [
        record.registrationId,
        record.fullName,
        record.birthDate ? moment(record.birthDate).format('YYYY-MM-DD') : '',
        record.birthDate ? moment().diff(moment(record.birthDate), 'years') : '',
        record.date ? moment(record.date).format('YYYY-MM-DD') : '',
        record.place?.address?.subcity || '',
        record.place?.address?.area || '',
        record.place?.address?.locationText || '',
    ].map(v => `"${String(v ?? '').replace(/"/g, '""')}"`).join(','));

    const csv = [headers.join(','), ...csvRows].join('\n');
    downloadCSV(csv, 'records_export');
};

export const RecordList= props => {
        const { permissions } = usePermissions();
        // Selection is only useful for finance, whose one bulk action it is.
        const isFinance = permissions.includes('finance') || permissions.includes('financeAdmin');
        return <List {...props} perPage={50}  filters={<RecordFilter/>}  exporter={recordExporter}  pagination={<ListPagination />}  sort={{ field: 'registrationId', order: 'DESC' }}>
            <Datagrid rowClick='show' bulkActionButtons={isFinance ? <RecordBulkActions /> : false}>
                <FunctionField label=" " sortable={false} render={record => (
                    <RecordAvatar record={record} alt={record.fullName} sx={{ width: 40, height: 40 }}>
                        {getInitials(record.fullName)}
                    </RecordAvatar>
                )} />
                <TextField source="registrationId"  />
                <TextField source="fullName" sortable={true} />
                <DateField label="Birth Date" source="birthDate" sortable={true} />
                <FunctionField label="Age" sortable={true}  render={record => moment().diff(moment(record.birthDate),"years")} />
                <DateField label="Registered On" source="date" sortable={true} />

                <ShowButton/>
                <EditButton/>

            </Datagrid>
        </List>
    }
;

export const RecordShow = (props) => {
    const { permissions } = usePermissions();
    // The allowance is finance business - the tab is hidden from everyone else,
    // and the panel's own queries are refused by the server regardless.
    const isFinance = permissions.includes('finance') || permissions.includes('financeAdmin');
    return <Show {...props} queryOptions={{ refetchOnMount: true }}>
        <TabbedShowLayout >
            <Tab label="Summary">
                <RecordSummery/>
<RecordActions/>


            </Tab>
            <Tab label="Personal">
                <TextField label="First Name" source="name" />
                <TextField label="Father Name"  source="fatherName"  />
                <TextField label="Grand Father Name" source="gFatherName" />
                <TextField  source="gender" />
                <DateField label="Birth Date" source="birthDate"/>
                {/*<ImageField label="Photo"  source="photo" />*/}
                <LightBoxField label="Photo" source="photo"/>

                <TextField label="Health Condition"  source="health.generalCondition"  />
                <TextField label="Health Remark"  source="health.remark"/>

                <TextField label="Level"  source="currentEducation.level"/>
                <TextField label="School Type"   source="currentEducation.schoolType" />
                <NumberField label="Grade"  source="currentEducation.grade"/>
                <TextField label="Distance From home"  source="currentEducation.distance" />

            </Tab>
            <Tab label="Families">
                <ArrayField label='Family Member'  source="families">
                    <Datagrid>
                        <TextField  source="relationship" />
                        <TextField label="First Name" source="name" />
                        {/*<TextField  source="gender" />*/}
                        <DateField label="Birth Date" source="birthDate"/>
                        <LightBoxField label="Photo" source="photo"/>

                        <TextField label="Health Condition"  source="health.generalCondition"  />
                        <TextField label="Health Remark"  source="health.remark"/>
                        <TextField label="Phone"  source="address.phones[0].number"/>
                    </Datagrid>
                </ArrayField>
            </Tab>
            <Tab label="Place">
                <TextField label="Place Name" source="place.name" />
                <TextField  label="City"  source="place.address.city" />
                <TextField  label="Sub City"  source="place.address.subcity" />
                <TextField label="Woreda"  source="place.address.woreda" />
                <TextField label="Area"  source="place.address.area" />
                <LightBoxField label="Photo" source="place.photo"/>
                <TextField  label="House Number"  source="place.address.houseNumber" />
                <TextField  label="Location Text"  source="place.address.locationText" />
                <TextField label="Remark"  source="place.address.remark" />
            </Tab>
            <Tab label="Story">
                <RichTextField label="Story"  source="story.story" />
                {/*<TextField label="Government Approved" source="story.governmentApproved" />*/}
                <ArrayField label='Attachments'  source="story.files">
                    <Datagrid>
                        <TextField  source="type" />
                        <TextField  source="title" />

                        <TextField label="Description"  source="description"  />
                        <FileField label="File" source="filePath"  title="title"  />

                    </Datagrid>
                </ArrayField>
                <ArrayField label='Photos'  source="story.photos">
                    <Datagrid>
                        <TextField  source="title" />

                        <LightBoxField label="Photo" source="filePath"/>

                        <TextField label="Description"  source="description"  />

                    </Datagrid>
                </ArrayField>
            </Tab>
            <Tab    label="Registration">
                <DateField source="date" />
                <TextField  label="Registration ID" source="registrationId" />
                <BooleanField label="Government Approved" source="official" />
               { permissions.includes("handler") && <div>
                <Typography  variant="h6" gutterBottom>Sponsor Info</Typography>
                <TextField label="Name" source="sponsor.name" />
                <TextField label="FatherName" source="sponsor.fatherName" />
                <TextField label="Phone" source="sponsor.address.phones[0].number" />
                <TextField label="Email" source="sponsor.address.email" />
                </div>}
                <TextField source="processedBy" />
            </Tab>
            {isFinance && (
                <Tab label="Payments">
                    <BeneficiaryPayments />
                </Tab>
            )}
        </TabbedShowLayout>
    </Show>;
}

const RecordForm = props =>

    <TabbedForm toolbar={<CustomToolbar tabs={5} {...props} />} {...props} redirect='list'  >
        <FormTab label="Personal">
            <FormDataConsumer>
                {formDataProps => (
                    <PersonalFormContent {...formDataProps}/>
                )}
            </FormDataConsumer>
        </FormTab>

        <FormTab   label="Family">
            <ArrayInput label='Family Member'  source="families">
                <SimpleFormIterator  >


                    <FormDataConsumer>
                        {formDataProps => (
                            <FamilyForm {...formDataProps}  />
                        )}
                    </FormDataConsumer>


                    {/*<Box display="flex" style={{width:"100%"}}>*/}
                    {/*    */}
                    {/*<TextInput label="Health Condition"  source="health.generalCondition" />*/}
                    {/*<TextInput label="Health Remark"  source="health.remark" />*/}
                    {/*</Box>*/}

                </SimpleFormIterator>
            </ArrayInput>
        </FormTab>


        <FormTab label="Place">
            <FormDataConsumer>
                {formDataProps => (
                    <PlaceFormContent {...formDataProps}/>
                )}
            </FormDataConsumer>
        </FormTab>

        <FormTab label="Story">
            <StoryContent/>
        </FormTab>

    <FormTab   label="Registration">

        <TextInput source="registrationId" />
        <DateInput options={{ format: 'DD/MM/YYYY' }} source="date" />
        <BooleanInput defaultValue={true} label="Government Approved"  source="official" />
        {!props.create&&<SelectInput defaultValue={"Active"} source="status" label='Status' choices={[
            {id: "Active", name: 'Active'},
            {id: "Discontinued", name: 'Discontinued'},
        ]}/>}
        <Typography variant="h6" gutterBottom>Sponsor Info</Typography>
        <TextInput label="Name" source="sponsor.name" />
        <TextInput label="FatherName" source="sponsor.fatherName" />
        <TextInput label="Phone" source="sponsor.address.phones[0].number" />
        <TextInput label="Email" source="sponsor.address.email" />
        <TextInput source="processedBy" />
    </FormTab>

</TabbedForm>

export const RecordEdit = props => (
    <Edit {...props}>
        <RecordForm/>
    </Edit>
);

export const RecordCreate = props => (
    <Create {...props}>
        <RecordForm create />
    </Create>
)

const Record = {list:RecordList,edit:RecordEdit,create:RecordCreate,show:RecordShow}

export default Record;
